import React from "react";
import Box from "@mui/material/Box";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TextField, useTheme } from "@mui/material";
import rightArrow from "../../assets/images/dashboard-image/right-arrow.svg";
import leftArrow from "../../assets/images/dashboard-image/left-arrow.svg";

const CustomDatePicker = ({
  selectedDate,
  minDate,
  onChange,
  id,
  name,
  error,
  helperText,
  placeholderText,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        "& input": {
          color: theme.palette.text.primary,
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
          padding: "10px",
          backgroundColor:
            theme.palette.mode === "dark"
              ? "transparent"
              : theme.palette.secondary.light,
          borderRadius: "4px",
        },
        "& .react-datepicker": {
          backgroundColor: theme.palette.background.paper,
          boxShadow:
            "rgba(0, 0, 0, 0.2) 0px 4px 5px -2px, rgba(0, 0, 0, 0.14) 0px 7px 10px 1px, rgba(0, 0, 0, 0.12) 0px 2px 16px 1px",
          border: "none",
        },
        "& .react-datepicker__day, .react-datepicker__day-name": {
          color: theme.palette.text.secondary,
        },
        "& .react-datepicker__day": {
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
        },
        "& .react-datepicker__current-month": {
          color: theme.palette.text.primary,
          marginTop: "6px",
        },
        "& .react-datepicker__header": {
          backgroundColor: "transparent",
          border: "none",
        },
        "& .react-datepicker__triangle": {
          display: "none",
        },
        "& .react-datepicker__navigation--next, .react-datepicker__navigation--previous":
          {
            width: "24px",
            height: "24px",
            backgroundColor: theme.palette.action.selected,
            borderRadius: "3px",
          },
        "& .react-datepicker__navigation--previous": {
          backgroundImage: `url(${leftArrow})`,
        },
        "& .react-datepicker__navigation--next": {
          backgroundImage: `url(${rightArrow})`,
        },
        "& .react-datepicker__day--selected": {
          backgroundColor: theme.palette.primary.main,
        },
        "& .react-datepicker__day--outside-month": {
          color: theme.palette.text.disabled,
        },
        "& .react-datepicker .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--in-range)":
          {
            backgroundColor: theme.palette.action.selected,
          },
        "& fieldset": {
          borderColor: theme.palette.border.primary,
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: "4px",
          "&:hover fieldset": {
            borderColor: theme.palette.primary.main,
          },
          "&.Mui-focused fieldset": {
            borderColor: theme.palette.primary.main,
          },
        },
        "& .MuiFormLabel-root": {
          color: theme.palette.primary.main,
          fontSize: "16px",
          lineHeight: "20px",
          transform: "translate(14px, 10px) scale(1)",
          "&.Mui-focused": {
            color: theme.palette.primary.main,
          },
        },
        "& .react-datepicker-wrapper, .react-datepicker__input-container": {
          display: "inline-flex",
          width: "100%",
        },
        "& .react-datepicker__day--disabled": {
          color: theme.palette.text.disabled,
          "&:hover": {
            backgroundColor: theme.palette.background.paper,
          },
        },
      }}
    >
      <ReactDatePicker
        id={id}
        name={name}
        selected={selectedDate}
        onChange={onChange}
        minDate={minDate}
        dateFormat="dd/MM/yyyy"
        placeholderText={placeholderText}
        customInput={
          <TextField error={error} helperText={helperText} fullWidth />
        }
      />
    </Box>
  );
};

export default CustomDatePicker;
